/**
 * factorServable — un facteur d'émission est-il « servable » (visible) dans un
 * picker de sélection, compte tenu du mode expert ?
 *
 * Sémantique STRICTE et UNIQUE :
 *   - vue standard  → public seulement : `factor.is_public === true`
 *   - mode expert   → tout facteur est servable
 *
 * La data est booléenne stricte partout (is_public ∈ {true, false}, 0 absent)
 * depuis MISSION-CLASSIF LOT A — c'est un INVARIANT. Ce helper est la défense
 * en profondeur contre tout futur doc non-strict (undefined / null / "true"
 * chaîne) : un tel doc ne sera JAMAIS traité comme public en vue standard
 * (seul `=== true` passe).
 *
 * Unifie 3 filtres inline historiquement divergents — `is_public === true`
 * (FactorSelectionStep), `is_public !== false` (FactorPickerInline),
 * `is_public` truthy (GlobalFactorSearch). Comportement INCHANGÉ tant que la
 * data reste strict-bool (les 3 sémantiques coïncident sur {true, false}).
 *
 * @param {object} factor - le facteur (peut être null/undefined).
 * @param {boolean} showExpert - true si le mode expert est actif.
 * @returns {boolean}
 */
export function factorServable(factor, showExpert = false) {
  if (showExpert) return true;
  return factor?.is_public === true;
}
